import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

export default function ADUsersResetPasswordDialog({
  handleReset,
  name,
  email,
  username,
  loading,
  onClose,
}: {
  handleReset: () => void;
  name: string;
  email: string;
  username: string;
  loading: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) onClose();
      }}
      open={true}
    >
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Resetar senha</DialogTitle>
          <DialogDescription>
            Você tem certeza que deseja resetar a senha de{" "}
            <strong>{username}</strong>? Esta ação não pode ser desfeita.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            disabled={loading}
            onClick={handleReset}
            variant={"destructive"}
          >
            {loading ? "Resetando..." : "Resetar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
